import React from 'react';
export const Welcome = React.lazy(() => import('./Welcome.jsx'));